module.exports = __webpack_public_path__ + "static/media/inspection-service.329039cc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/inspection-service.jpg
// module id = 576
// module chunks = 0